import React from 'react';
import { Menu, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SUPPORTED_LANGUAGES } from '../constants/languageConfig';
import { Button } from '../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';

/**
 * Header - Top navigation bar with menu toggle and language selector
 * @param {Object} props
 * @param {Function} props.onMenuClick - Callback to toggle navigation drawer
 */
export default function Header({ onMenuClick }) {
  const { language, setLanguage, availableLanguages, t } = useLanguage();

  const currentLang = SUPPORTED_LANGUAGES[language];

  return (
    <header className="flex items-center gap-4 px-4 py-2 bg-gradient-to-r from-[#3c618a] to-[#5a4f8a] text-white shadow-md z-50 min-h-[48px]">
      <Button
        variant="ghost"
        size="icon"
        onClick={onMenuClick}
        aria-label={t('navigation.toggleNavigation', 'Toggle navigation')}
        className="text-white hover:bg-white/10"
      >
        <Menu className="h-5 w-5" />
      </Button>

      <h1 className="flex-1 text-lg font-semibold uppercase" style={{ fontFamily: 'Lato, Arial, sans-serif' }}>
        Gardeno Games - UCG Toolbox
      </h1>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="text-white hover:bg-white/10 gap-2"
          >
            <Globe className="h-4 w-4" />
            <span className="text-base">{currentLang?.flag}</span>
            <span className="hidden sm:inline">{currentLang?.nativeName || language}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuRadioGroup value={language} onValueChange={setLanguage}>
            {availableLanguages.map((code) => {
              const lang = SUPPORTED_LANGUAGES[code];
              return (
                <DropdownMenuRadioItem key={code} value={code}>
                  <span className="mr-2">{lang?.flag}</span>
                  {lang?.nativeName || code}
                </DropdownMenuRadioItem>
              );
            })}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
